import { useState,useEffect,useRef } from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/customButton";
import editProfileIcon from "../../assets/images/editProfileBlue.svg";
import exitIcon from "../../assets/images/exitBlue.svg";


let ROLE_NAME='Softawre Developer'

const BOOTSTRAP_CSS = `
  .chat-bubble-ai { border-bottom-left-radius: 4px !important; }
  .chat-bubble-user { border-bottom-right-radius: 4px !important; background-color: #444ce7 !important; }
  .chat-container { scroll-behavior: smooth; }
 
  /* Modal Overlay fix for React without bootstrap.js */
  .react-modal-backdrop { background-color: rgba(0,0,0,0.5); position: fixed; inset: 0; z-index: 1040; }
  .react-modal { display: block; z-index: 1050; }
`;

const ScreeninAi = ({  onDashboard }) => {


  const [messages, setMessages] = useState([
    { id: 1, sender: 'AI', text: `Hi there! I'm the LYWO AI Assistant. Let's get started with your screening for the ${ROLE_NAME} role. Can you briefly tell me about your background?` }
  ]);
  const [inputText, setInputText] = useState('');



 
  // Chat Phases: 1: Intro, 2: Awaiting OTP, 3: Technical (Timed), 4: Finished
  const [chatPhase, setChatPhase] = useState(1);
 
  // Timer State
  const [timeLeft, setTimeLeft] = useState(5 * 60); // 5 minutes
  const [isTimerActive, setIsTimerActive] = useState(false);
 
  // Modals
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [showExitWarning, setShowExitWarning] = useState(false);
  const [otpInput, setOtpInput] = useState('');

  const [isMobileView,setIsMobileView] = useState(false)

  const messagesEndRef = useRef(null);


  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);


  // Auto-scroll to bottom of chat
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => { scrollToBottom(); }, [messages]);

  const navigate = useNavigate()

  const onComplete =()=>{
 

    navigate('/screeningCompletion')


  }


  // Timer countdown effect
  useEffect(() => {
    let interval = null;
    if (isTimerActive && timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft(time => time - 1);
      }, 1000);
    } else if (timeLeft === 0 && isTimerActive) {
      setIsTimerActive(false);
      handleTimeUp();
    }
    return () => clearInterval(interval);
  }, [isTimerActive, timeLeft]);


  const handleSendMessage = (e) => {
    e.preventDefault();
    if (!inputText.trim()) return;


    const newMsg = { id: Date.now(), sender: 'Candidate', text: inputText };
    setMessages(prev => [...prev, newMsg]);
    setInputText('');


    // Mock AI Progression Logic based on current phase
    setTimeout(() => {
      if (chatPhase === 1) {
        setMessages(prev => [...prev, { id: Date.now()+1, sender: 'AI', text: "Thank you. Now, we'll move on to a timed technical question. Before I reveal the question, we need to verify your identity." }]);
        setTimeout(() => setShowOTPModal(true), 1500);
        setChatPhase(2);
      } else if (chatPhase === 3) {
        setIsTimerActive(false);
        setMessages(prev => [...prev, { id: Date.now()+1, sender: 'AI', text: "Got it. Your response has been recorded. Thank you for completing the screening!" }]);
        setChatPhase(4);
        setTimeout(() => onComplete(), 3000);
      }
    }, 1000);
  };


  const handleTimeUp = () => {
    setMessages(prev => [...prev, { id: Date.now()+1, sender: 'AI', text: "Time is up! We have automatically recorded your progress. Thank you for completing the screening." }]);
    setChatPhase(4);
    setTimeout(() => onComplete(), 3500);
  };


  const verifyOTP = () => {
    if (otpInput.length >= 4) {
      setShowOTPModal(false);
      setMessages(prev => [...prev, { id: Date.now()+1, sender: 'AI', text: "Identity verified successfully. You have 5 minutes to answer the following question: Explain the rendering lifecycle of a React component and how Hooks interact with it." }]);
      setChatPhase(3);
      setIsTimerActive(true);
    }
  };


  const handleDashboardClick = () => {
    if (isTimerActive) {
      setShowExitWarning(true);
    } else {
      // onDashboard();
    }
  };


  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? '0' : ''}${s}`;
  };


  return (
    <>
     <style>{BOOTSTRAP_CSS}</style>
    <div className="d-flex flex-column vh-100 bg-light position-relative">
     
      {/* Header */}
      <header className="bg-white border-bottom shadow-sm p-3 d-flex justify-content-between align-items-center z-1">
        <div>
          <h6 className="mb-0 fw-bold text-dark">LYWO Screening</h6>
          <small className="text-muted">{ROLE_NAME}</small>
        </div>
        <div className="d-flex align-items-center gap-3">
          {/* Subtle visible timer only during Step 3 */}
          {chatPhase === 3 && (
            <span className={`badge ${timeLeft < 60 ? 'bg-danger' : 'bg-warning text-dark'} px-3 py-2 fs-6 rounded-pill`}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-clock me-1 mb-1" viewBox="0 0 16 16">
                <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z"/>
                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0"/>
              </svg>
              {formatTime(timeLeft)}
            </span>
          )}
          {
            isMobileView?
            <>
            <div className="mobile-icon-txt" 
            // onClick={()=>setShowSubmitModal(true)}
            >
              
                        <img src={editProfileIcon} className="mobIcon" alt="Edit Profile" />
                        {/* <p>Dashboard</p> */}
                        
                    </div>
            <div className="mobile-icon-txt" 
            // onClick={()=>setShowSubmitModal(true)}
            >
                                    <img src={exitIcon} className="mobIcon" alt="Exit" />
                                    {/* <p>Exit</p> */}
                                </div>

            
            </>
            :<>
          <button

            className="white"
                                        // onClick={()=>setShowSubmitModal(true)}
            style={{ width: "180px", padding: "8px 14px", height: "40px" }}
            >
                Candidate Dashboard
            </button>
          <button
          
            className="white"
                                        // onClick={()=>setShowSubmitModal(true)}
            style={{ width: "100px", padding: "8px 14px", height: "40px" }}
          onClick={handleDashboardClick} title="Exit">
            Exit
          </button>
          </>
          }
        </div>
      </header>


      {/* Chat Messages Area */}
      <div className="flex-grow-1 overflow-auto p-3 p-md-4 chat-container">
        <div className="d-flex flex-column mx-auto" style={{ maxWidth: '800px' }}>
         
          <div className="text-center mb-4">
            <small className="text-muted bg-white px-3 py-1 rounded-pill border shadow-sm">
              Today, {new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
            </small>
          </div>


          {messages.map((msg) => (
            <div
              key={msg.id}
              className={`d-flex flex-column mb-3 ${msg.sender === 'Candidate' ? 'align-items-end' : 'align-items-start'}`}
            >
              <div
                className={`p-3 rounded-4 shadow-sm ${msg.sender === 'Candidate' ? ' text-white chat-bubble-user' : 'bg-white text-dark border chat-bubble-ai'}`}
                style={{ maxWidth: '85%' }}
              >
                <p className="mb-0 lh-base">{msg.text}</p>
              </div>
              <small className="text-muted mt-1 px-1" style={{ fontSize: '0.75rem' }}>
                {msg.sender === 'AI' ? 'LYWO Assistant' : 'You'}
              </small>
            </div>
          ))}
          <div ref={messagesEndRef} />
        </div>
      </div>


      {/* Input Area */}
      <footer className="bg-white border-top p-3 z-1">
        <form onSubmit={handleSendMessage} className="mx-auto d-flex gap-2" style={{ maxWidth: '800px' }}>
          <input
            type="text"
            className="form-control form-control-lg rounded-pill bg-light border-0 px-4"
            placeholder={chatPhase === 2 ? "Waiting for verification..." : "Type your message..."}
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            disabled={chatPhase === 2 || chatPhase === 4}
            autoComplete="off"
          />
          <button
            type="submit"
            className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center"
            style={{ width: '50px', height: '50px', flexShrink: 0 }}
            disabled={!inputText.trim() || chatPhase === 2 || chatPhase === 4}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-send-fill ms-1" viewBox="0 0 16 16">
              <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"/>
            </svg>
          </button>
        </form>
      </footer>


      {}
     
      {/* OTP Step-Up Auth Modal */}
      {showOTPModal && (
        <>
          <div className="react-modal-backdrop"></div>
          <div className="modal react-modal" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content border-0 shadow">
                <div className="modal-header border-bottom-0 pb-0">
                  <h5 className="modal-title fw-bold">Identity Verification</h5>
                </div>
                <div className="modal-body">
                  <p className="text-muted">For fairness and security, timed technical questions require a quick verification. Enter the 4-digit code sent to your registered phone number.</p>
                  <input
                    type="text"
                    className="form-control form-control-lg text-center letter-spacing-lg fw-bold"
                    placeholder="• • • •"
                    maxLength="4"
                    value={otpInput}
                    onChange={(e) => setOtpInput(e.target.value.replace(/[^0-9]/g, ''))}
                    autoFocus
                  />
                  <small className="text-muted mt-2 d-block text-center">Hint: Type any 4 numbers to proceed in this demo.</small>
                </div>
                <div className="modal-footer border-top-0 pt-0">
                  <CustomButton
                  title='Verify & Continue'
                  style={{width:'100%'}}
                    handleClick={verifyOTP} 
                    isDisabled={otpInput.length < 4}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}


      {/* Exit-Time Warning Modal */}
      {showExitWarning && (
        <>
          <div className="react-modal-backdrop"></div>
          <div className="modal react-modal" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content border-0 shadow">
                <div className="modal-header bg-light">
                  <h5 className="modal-title fw-bold text-dark">Leaving so soon?</h5>
                </div>
                <div className="modal-body">
                  <p className="mb-0 text-dark">
                    No rush — your progress is saved. For fairness, the timed questions are monitored, so try to complete them in one go where you can. You've got this.
                  </p>
                </div>
                <div className="modal-footer d-flex flex-column flex-sm-row gap-2 border-top-0">
                  <button

            className="white"
                                        // onClick={()=>setShowSubmitModal(true)}
            style={{ width: "100%", padding: "8px 14px", height: "40px" }}
            onClick={() => { setShowExitWarning(false); 
              // onDashboard()
               }}
            >
                Candidate Dashboard
            </button>
            <CustomButton
            title='Stay and finish'
            handleClick={() => setShowExitWarning(false)}
            style={{width:'100%'}}
            />
                  {/* <button type="button" className="btn btn-primary w-100 m-0" onClick={() => setShowExitWarning(false)}>
                    Stay and finish
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
    </>
  );
};

export default ScreeninAi